import { render, staticRenderFns } from "./ProductValueRenderer.vue?vue&type=template&id=d2747810"
import script from "./ProductValueRenderer.vue?vue&type=script&lang=ts"
export * from "./ProductValueRenderer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports